/**
 * @generated SignedSource<<66d3e43c9e67758a9a1859bdd19133d0>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CarouselThumb_viewInRoomPhoto$data = {
  readonly credits: string | null;
  readonly src: string | null;
  readonly " $fragmentType": "CarouselThumb_viewInRoomPhoto";
};
export type CarouselThumb_viewInRoomPhoto$key = {
  readonly " $data"?: CarouselThumb_viewInRoomPhoto$data;
  readonly " $fragmentSpreads": FragmentRefs<"CarouselThumb_viewInRoomPhoto">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CarouselThumb_viewInRoomPhoto",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "src",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "credits",
      "storageKey": null
    }
  ],
  "type": "viewInRoomPhotos",
  "abstractKey": null
};

(node as any).hash = "4da1e7eb78e2fa382e7f23aeb8f01315";

export default node;
